import { render, staticRenderFns } from "./TvDetails.vue?vue&type=template&id=a8094ab2&scoped=true&"
import script from "./TvDetails.vue?vue&type=script&lang=js&"
export * from "./TvDetails.vue?vue&type=script&lang=js&"
import style0 from "./TvDetails.vue?vue&type=style&index=0&id=a8094ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8094ab2",
  null
  
)

export default component.exports